import { DarkMode, LightMode, RechargeDarkMode, RechargeLightMode, Typography } from '@sede-x/shell-ds-fabrics';

export enum ThemeModes {
  dark = 'dark',
  light = 'light',
  rechargeLight = 'rechargeLight',
  rechargeDark = 'rechargeDark',
}

export type ThemeMode = `${ThemeModes}`;

export type AccentColor = {
  strong: string;
  medium: string;
  subtle: string;
};

export type Accent = {
  primary: AccentColor;
  secondary: AccentColor;
};

export type SystemColors = {
  neutral: string;
  positive: string;
  negative: string;
  warning: string;
  information: string;
};

export type TextColors = {
  strong: string;
  subtle: string;
  inactive: string;
  link: string;
};

export type SystemTextColors = {
  strong: SystemColors;
  subtle: SystemColors;
};

export const themes = {
  [ThemeModes.light]: { name: ThemeModes.light, ...LightMode, ...Typography },
  [ThemeModes.dark]: { name: ThemeModes.dark, ...DarkMode, ...Typography },
  [ThemeModes.rechargeLight]: { name: ThemeModes.rechargeLight, ...RechargeLightMode, ...Typography },
  [ThemeModes.rechargeDark]: { name: ThemeModes.rechargeDark, ...RechargeDarkMode, ...Typography },
} as const;

export enum ColorModes {
  surface = 'surface',
  sentiment = 'sentiment',
  prominence = 'prominence',
  emphasis = 'emphasis',
  state = 'state',
  entity = 'entity',
  entitySurfaceMode = 'entitySurfaceMode',
  entitySentimentMode = 'entitySentimentMode',
}

export enum ColorType {
  onSurface = 'onSurface',
  onSentiment = 'onSentiment',
}

export enum ColorEntitySurfaceModes {
  strong = 'strong',
  medium = 'medium',
  subtle = 'subtle',
}

export enum ColorEntitySentimentModes {
  default = 'default',
  colour = 'colour',
}

export enum ColorEntities {
  border = 'border',
  text = 'text',
  background = 'background',
}

export const COLOR_PATHES = {
  [ColorType.onSentiment]: [
    ColorModes.emphasis,
    ColorModes.prominence,
    ColorModes.sentiment,
    ColorModes.state,
    ColorModes.entity,
    ColorModes.entitySentimentMode,
  ],
  [ColorType.onSurface]: [ColorModes.surface, ColorModes.state, ColorModes.entity, ColorModes.entitySurfaceMode],
};

export type LayerConfigType = {
  [key in ColorModes]?: string;
};

export type LayerConfigWithType = LayerConfigType & {
  type?: ColorType;
};

type EntityOverrideType = 'none' | LayerConfigWithType;

export type EntityOverridesType =
  | undefined
  | {
      [key in ColorEntities]?: EntityOverrideType;
    };

export type ColorConfigType = {
  [key in ColorEntities]?: string;
};

export type Theme = { name: ThemeMode } & typeof LightMode & typeof Typography;
